import { render, staticRenderFns } from "./seedling_by_period_index.vue?vue&type=template&id=60fbf554&scoped=true&"
import script from "./seedling_by_period_index.vue?vue&type=script&lang=js&"
export * from "./seedling_by_period_index.vue?vue&type=script&lang=js&"
import style0 from "./seedling_by_period_index.vue?vue&type=style&index=0&id=60fbf554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fbf554",
  null
  
)

export default component.exports